import { c as _c } from "react/compiler-runtime";
import { IdDocImageTypes } from '@onefootprint/types';
import upperCase from 'lodash/upperCase';
import upperFirst from 'lodash/upperFirst';
import { useTranslation } from 'react-i18next';
import PhotoCapture from '../../../components/photo-capture/photo-capture';
import { ID_OUTLINE_HEIGHT_RATIO, ID_OUTLINE_WIDTH_RATIO } from '../../../constants';
import type { CameraErrorCause, ReceivedImagePayload } from '../../../types';
import useDocName from '../../hooks/use-doc-name';
import useIdDocMachine from '../../hooks/use-id-doc-machine';
const FrontPhotoCapture = () => {
  const $ = _c(39);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "document-flow.id-doc.pages.front-photo-capture"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("idv", t0);
  const [state, send] = useIdDocMachine();
  const {
    idDoc: t1,
    requirement,
    hasBadConnectivity,
    allowPdf
  } = state.context;
  const {
    type: docType
  } = t1;
  let t2;
  if ($[1] !== docType) {
    t2 = {
      docType,
      imageType: IdDocImageTypes.front
    };
    $[1] = docType;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    getDocName,
    getSideName
  } = useDocName(t2);
  if (!docType) {
    return null;
  }
  let docName;
  let t3;
  if ($[3] !== getDocName) {
    docName = getDocName();
    t3 = upperFirst(docName);
    $[3] = getDocName;
    $[4] = docName;
    $[5] = t3;
  } else {
    docName = $[4];
    t3 = $[5];
  }
  const docNameCapitalized = t3;
  let sideName;
  let t4;
  if ($[6] !== getSideName) {
    sideName = getSideName();
    t4 = upperCase(sideName);
    $[6] = getSideName;
    $[7] = sideName;
    $[8] = t4;
  } else {
    sideName = $[7];
    t4 = $[8];
  }
  const sideNameCapitalized = t4;
  let t5;
  if ($[9] !== send) {
    t5 = payload => send({
      type: "receivedImage",
      payload
    });
    $[9] = send;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const onComplete = t5;
  let t6;
  if ($[11] !== send) {
    t6 = () => {
      send({
        type: "navigatedToPrev"
      });
    };
    $[11] = send;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const handleClickBack = t6;
  let t7;
  if ($[13] !== send) {
    t7 = () => {
      send({
        type: "cameraStuck"
      });
    };
    $[13] = send;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const handleCameraStuck = t7;
  let t8;
  if ($[15] !== send) {
    t8 = cause => {
      send({
        type: "cameraErrored",
        payload: {
          cause
        }
      });
    };
    $[15] = send;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  const handleCameraErrored = t8;
  let t9;
  if ($[17] !== send) {
    t9 = () => {
      send({
        type: "cameraAccessDenied",
        payload: {
          status: "denied"
        }
      });
    };
    $[17] = send;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  const handleCameraAccessDenied = t9;
  const cameraTitle = `${docNameCapitalized} · ${sideNameCapitalized}`;
  const previewTitle = `${docNameCapitalized}`;
  let t10;
  if ($[19] !== cameraTitle || $[20] !== previewTitle) {
    t10 = {
      camera: cameraTitle,
      preview: previewTitle
    };
    $[19] = cameraTitle;
    $[20] = previewTitle;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t) {
    t11 = t(_temp);
    $[22] = t;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t11) {
    t12 = {
      preview: t11
    };
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== allowPdf || $[27] !== docName || $[28] !== handleCameraAccessDenied || $[29] !== handleCameraErrored || $[30] !== handleCameraStuck || $[31] !== handleClickBack || $[32] !== hasBadConnectivity || $[33] !== onComplete || $[34] !== requirement || $[35] !== sideName || $[36] !== t10 || $[37] !== t12) {
    t13 = <PhotoCapture autocaptureKind="idDoc" cameraKind="back" deviceKind="mobile" allowPdf={allowPdf} sideName={sideName} docName={docName} side={IdDocImageTypes.front} requirement={requirement} hasBadConnectivity={hasBadConnectivity} outlineHeightRatio={ID_OUTLINE_HEIGHT_RATIO} outlineWidthRatio={ID_OUTLINE_WIDTH_RATIO} title={t10} subtitle={t12} onComplete={onComplete} onBack={handleClickBack} onCameraStuck={handleCameraStuck} onCameraErrored={handleCameraErrored} onCameraAccessDenied={handleCameraAccessDenied} />;
    $[26] = allowPdf;
    $[27] = docName;
    $[28] = handleCameraAccessDenied;
    $[29] = handleCameraErrored;
    $[30] = handleCameraStuck;
    $[31] = handleClickBack;
    $[32] = hasBadConnectivity;
    $[33] = onComplete;
    $[34] = requirement;
    $[35] = sideName;
    $[36] = t10;
    $[37] = t12;
    $[38] = t13;
  } else {
    t13 = $[38];
  }
  return t13;
};
export default FrontPhotoCapture;
function _temp($) {
  return $.subtitle.preview;
}